import type { RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw } from 'vue-router'
import { Site, SLD } from '@patsnap-utils/biz';

interface RedirectRule {
    pattern: RegExp
    replacement: string | ((path: string) => string)
}

/**
 * 20260318发布版本所有agent都在ip/#/home?agent=xxxx,现在发20260331有将所有agent迁移出来了这个函数处理这个重定向的,操蛋
 * @param targetPath
 * @returns
 */
function createIPAgentRedirect(targetPath: string) {
    return (path: string) => {
        const [, hashQuery] = new URL(path, 'http://localhost').hash.split('?')
        if (!hashQuery) return targetPath

        const params = new URLSearchParams(hashQuery)
        params.delete('agent')
        if (!params.size) return targetPath

        const [base, existingQuery] = targetPath.split('?')
        const merged = new URLSearchParams(existingQuery)
        params.forEach((value, key) => merged.set(key, value))

        return `${base}?${merged}`
    }
}

const redirectRules: RedirectRule[] = [
    { pattern: /^\/results\/standard(?=\/|$|\?)/, replacement: 'results/#/standard' },
    { pattern: /^\/results\/design(?=\/|$|\?)/, replacement: 'results/#/design' },
    { pattern: /^\/results\/analysis(?=\/|$|\?)/, replacement: 'results/#/analysis' },
    { pattern: /^\/technology-roadmap\/#\/create$/, replacement: 'rd/#/roadmap/create' },
    { pattern: /^\/technology-roadmap\/#\/detail(\/.*)?$/, replacement: 'roadmap-view/#/detail$1' },
    { pattern: /^\/technology-roadmap(\/|\/#|\/#\/)?$/, replacement: 'rd/#/roadmap' },
    { pattern: /^\/air\/#\/page(\/.*)?$/, replacement: 'page$1' },
    { pattern: /^\/material(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/material\/search(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/home\/chat(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/home\/search(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/material\/chat(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/air\/#\/user-setting\/package(\/|\/#|\/#\/)?$/, replacement: 'user-setting/package' },
    { pattern: /^\/air\/#\/user-setting\/amount(\/|\/#|\/#\/)?$/, replacement: 'user-setting/amount' },
    { pattern: /^\/air(\/|\/#|\/#\/)?(\?.*)?$/, replacement: 'home' },
    { pattern: /^\/newsletter\/#\/detail\/(\d+)(?=\/|$|\?)/, replacement: 'monitor/#/report/$1' },
    { pattern: /^\/newsletter\/#\/mySubscription(?=\/|$|\?)/, replacement: 'monitor/#/my' },
    { pattern: /^\/newsletter\/#\/topics(?=\/|$|\?)/, replacement: 'monitor/#/topics' },
    { pattern: /^\/newsletter\/#\/subscription(?=\/|$|\?)/, replacement: 'monitor/#/subscription' },
    { pattern: /^\/newsletter\/#\/result(?=\/|$|\?)/, replacement: 'monitor/#/result' },
    { pattern: /^\/newsletter(?=\/|$|\?)/, replacement: 'monitor' },
    { pattern: /^\/graph\/(.+)/, replacement: 'rd/#/graph/$1' },
    { pattern: /^\/graph(\/)?$/, replacement: 'rd/#/graph' },
    { pattern: /^\/roadmap\/create(\/)?$/, replacement: 'rd/#/roadmap/create' },
    { pattern: /^\/roadmap(\/)?$/, replacement: 'rd/#/roadmap' },
    // #region  IP 相关路由重定向 checking
    // 查新
    { pattern: /^\/ip\/novelty-check-report\/([^/?]+)/, replacement: 'ip/checking/#/novelty-check-report?task_id=$1' },
    { pattern: /^\/ai-drafting\/novelty-check-report(\/.*)?(?=\/|$|\?)/, replacement: 'ip/checking/#/novelty-check-report$1' },
    { pattern: /^\/ip\/#\/(guest|home)\?agent=novelty/, replacement: createIPAgentRedirect('ip/checking/#/novelty-check-report') },
    // FTO
    { pattern: /^\/ip\/fto-pro\/([^/?]+)/, replacement: 'ip/checking/#/fto-pro?task_id=$1' },
    { pattern: /^\/ai-drafting\/fto-pro\/([^/?]+)/, replacement: 'ip/checking/#/fto-pro?task_id=$1' },
    { pattern: /^\/ip\/#\/(guest|home)\?agent=fto/, replacement: createIPAgentRedirect('ip/checking/#/fto-pro') },
    // 老FTO
    { pattern: /^\/ip\/fto-report\/([^/?]+)/, replacement: 'ip/checking/#/fto-report?task_id=$1' },
    { pattern: /^\/ai-drafting\/fto-report(\/.*)?(?=\/|$|\?)/, replacement: 'ip/checking/#/fto-report?task_id=$1' },
    // 外观FTO
    { pattern: /^\/ai-drafting\/design-fto\/([^/?]+)/, replacement: 'ip/checking/#/design-fto?task_id=$1' },
    { pattern: /^\/ai-ip\/image-fto-search\/([^/?]+)/, replacement: 'ip/#/home?agent=design_infringement' },
    { pattern: /^\/ip\/#\/(guest|home)\?agent=design_infringement/, replacement: createIPAgentRedirect('ip/checking/#/design-fto') },
    // 撰写相关
    { pattern: /^\/ip\/#\/(guest|home)\?agent=prosecution/, replacement: createIPAgentRedirect('ip/drafting/#/?agent=prosecution') },
    { pattern: /^\/ip\/#\/(guest|home)\?agent=patent_draft/, replacement: createIPAgentRedirect('ip/drafting/#/?agent=patent_draft') },
    { pattern: /^\/ip\/#\/(guest|home)\?agent=disclosure/, replacement: createIPAgentRedirect('ip/drafting/#/?agent=disclosure') },
    // #endregion
    // 新老要并存,暂时不做重定向
    // { pattern: /^\/ai\/agent-flow\/([^/?]+)/, replacement: 'ip/checking#/design-fto?task_id=$1' },
    // IP 相关路由重定向 drafting
    { pattern: /^\/ip\/home\?tab=ai_specification/, replacement: 'ip/#/home?agent=drafting' },
    // { pattern: /^\/ip\/home(?=\/|$|\?)/, replacement: 'ip/#/home' },
    { pattern: /^\/ip\/specification\/([^/?]+)/, replacement: 'ip/checking/#/specification?taskId=$1' },
    { pattern: /^\/ai-drafting\/specification\/([^/?]+)/, replacement: 'ip/checking/#/specification?taskId=$1' },
    { pattern: /^\/drafting\/#\/specification/, replacement: 'ip/checking/#/specification' },
    { pattern: /^\/ip\/disclosure\/([^/?]+)/, replacement: 'ip/checking/#/disclosure?taskId=$1' },
    { pattern: /^\/ai-drafting\/disclosure\/([^/?]+)/, replacement: 'ip/checking/#/disclosure?taskId=$1' },
    { pattern: /^\/drafting\/#\/disclosure/, replacement: 'ip/checking/#/disclosure' },
    { pattern: /^\/ip\/translation\/([^/?]+)/, replacement: 'ip/checking/#/translation?taskId=$1' },
    { pattern: /^\/ai-drafting\/translation\/([^/?]+)/, replacement: 'ip/checking/#/translation?taskId=$1' },
    { pattern: /^\/drafting\/#\/translation/, replacement: 'ip/checking/#/translation' },
    // ip2026.3.18游客版落地页重定向到2026.3.31版本的新落地页
    { pattern: /^\/ip\/#\/guest/, replacement: 'ip-landing' },
    // /ip 或 /ip?xxx 重定向到查新报告，原 query 一并透传
    { pattern: /^\/ip(\?.*)?$/, replacement: 'ip/checking/#/novelty-check-report$1' },
    // ip 的兜底规则,上面没有匹配到的,都重定向到home
    { pattern: /^\/ip(\/.*)?$/, replacement: 'home' }
]

function getRedirectPath(path: string): string | null {
    for (const { pattern, replacement } of redirectRules) {
        if (pattern.test(path)) {
            return typeof replacement === 'function' ? replacement(path) : path.replace(pattern, replacement)
        }
    }
    return null
}

export const deprecatedRouter: RouteRecordRaw = {
    path: '/:catchAll(.*)',
    component: () => {},
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
        const newPath = getRedirectPath(to.fullPath)
        if (newPath) {
            const fullPath = new Site({ sld: SLD.EUREKA, pathname: newPath }).href
            window.location.replace(fullPath)
        } else {
            next('/404')
        }
    },
}
